import axios from "axios";
const API_BASE_URL = "https://fishbot-backend.herokuapp.com/";

export const commandhistorylookupApi = (theUsername) => axios.create({
  baseURL: API_BASE_URL + "api/playercommandhistory/"+theUsername,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
